<template>
  <div>
    <el-dialog
        :title="'Tạo ví cho trường'"
        :visible.sync="showCreateCashBookDialog"
        width="600px"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        top="10vh"
    >
      <div>
        <el-row>
          <el-col :span="2">
            <el-date-picker
                style="width: 150px"
                size="medium"
                v-model="dataInput.year"
                type="year"
                value-format="yyyy"
                format="yyyy"
                placeholder="Chọn năm"
                :clearable="false"
            ></el-date-picker>
          </el-col>
          <el-col :span="2" :offset="5">
            <el-select
                size="medium"
                v-model="dataInput.idSchool"
                placeholder="Chọn trường"
                filterable
                clearable
                style="width: 250px"
            >
              <el-option
                  v-for="item in schoolList"
                  :key="item.id"
                  :label="item.id+' - '+item.schoolName"
                  :value="item.id"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col :span="2">
            <el-button
                size="small"
                :loading="buttonLoading"
                @click="createCashBookOneAdminManual()"
                type="primary"
            >Tạo ví cho trường
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import OtherService from "@/services/CommonService/OtherService";

export default {
  props: {
    showCreateCashBookDialog: {
      type: Boolean,
      default: () => false
    },
    schoolList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dataInput: {
        year: "",
        idSchool: "",
      },
      buttonLoading: false,
      listSchool: [],
    };
  },

  methods: {
    closeDialog() {
      this.dataInput.year = "";
      this.dataInput.idSchool = "";
      this.buttonLoading = false
      this.$emit('close', false);
    },
    createCashBookOneAdminManual() {
      if (this.dataInput.year === "") {
        this.$message({
          message: "Chọn năm khởi tạo ví",
          type: "error",
        });
        return
      }
      if (this.dataInput.idSchool === "") {
        this.$message({
          message: "Chọn trường khởi tạo ví",
          type: "error",
        });
        return;
      }
      this.$confirm(
          "Bạn có chắc chắn muốn tạo ví không?",
          "Thông báo!",
          {
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            confirmButtonText: "Có",
            cancelButtonText: "Không",
          }
      ).then(async () => {
        this.buttonLoading = true;
        let data = {
          year: Number(this.dataInput.year),
          idSchool: Number(this.dataInput.idSchool),
        }
        await OtherService.createCashBookOneAdmin(data)
            .then((resp) => {
              this.$message({
                message: resp.data.message,
                type: "success",
              });
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            })
            .finally(() => {
              setTimeout(() => {
                this.buttonLoading = false;
              }, 1000);
            });
      });
    },

  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__title {
  font-size: 25px;
  color: #606266;
}
</style>
